import {useState, useRef, useEffect} from 'react';
import practiceViewStyles from 'components/PracticeView/practice-view-variables.scss';
import globalNavStyles from 'client/GlobalNavigation/global-navigation.scss';

const titleBarHeight = parseInt(practiceViewStyles.titleBarHeight, 10);
const mobileToolbarHeight = parseInt(practiceViewStyles.mobileToolbarHeight, 10);
const globalNavHeight = parseInt(globalNavStyles.globalNavHeight, 10);

const labelOffset = 20;
const marginOffset = 20;

const toolbarsHeight = titleBarHeight + mobileToolbarHeight + globalNavHeight;
const verticalScaleMultiplier = 0.85;

// eslint-disable-next-line import/prefer-default-export
export function useMaxGraphDimensions({hasLeftLabel, hasBottomLabel}) {
  const [size, setSize] = useState(null);
  const wrapperRef = useRef();

  useEffect(() => {
    if (size || !wrapperRef.current) {
      return;
    }
    const maxWidth =
      wrapperRef.current.getBoundingClientRect().width -
      marginOffset -
      (hasLeftLabel ? labelOffset : 0);
    const maxHeight =
      (global.window?.innerHeight - toolbarsHeight - (hasBottomLabel ? labelOffset : 0)) *
      verticalScaleMultiplier;

    setSize({
      maxWidth,
      maxHeight
    });
  }, [size, hasLeftLabel, hasBottomLabel]);

  return {
    wrapperRef,
    ready: !!size,
    maxHeight: size?.maxHeight,
    maxWidth: size?.maxWidth
  };
}
